import(/* webpackMode: "eager" */ "/vercel/path0/app/platform/page.tsx");
